import { INFO_MODULE_VIEWS } from "config/userPermissions";

const INFORMATION_LINKS = [
    {
        title: "Eventos", 
        description: "Crea eventos, talleres, conferencias y demás."
    }, 
    {
        title: "Refuerzo académico", 
        description: "Talleres y tutorías para reforzar las clases.", 
    }, 
    {
        title: "Asesorías", 
        description: "Psicológicas, internacional y de empleabilidad", 
    }, 
    {
        title: "Recursos", 
        description: "Notas e información adicional", 
    }
];
export const HOME_CARD_LINK_PROPS_LIST = INFORMATION_LINKS
    .map((info, idx) => {
        const { path, ...restInfoModuleViews } = INFO_MODULE_VIEWS[idx];
        return { 
            to: `/${path}`, 
            ...restInfoModuleViews, 
            ...info 
        };
    });